#import "../fragments/email-list-item-fragment.graphql"

query GetReceivedEmails($limit: Int!, $cursor: String) {
    receivedEmails(first: $limit, after: $cursor) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            cursor
            node {
                ...EmailListItem
            }
        }
    }
}
